import { AxiosRequestConfig } from 'axios';
import { UseAxios } from './useAxiosBeta.types';
import { useEffectOnce } from '../useEffectOnce/useEffectOnce';
import useBaseAxios from './useBaseAxios';

const useAxiosBeta: UseAxios = <Data,>(endpoint: string, config?: AxiosRequestConfig) => {
    const [getData, { cancel, refetch, ...dataStates}] = useBaseAxios<Data>(endpoint, config);
    
    useEffectOnce(() => {
        getData();
    })
    
    return {
        ...dataStates,
        refetch,
        cancel,
    }
}

export default useAxiosBeta;